<template>
    <div class="card">
        <div class="card-header">Confirm</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <form-summary :validator="$v.screen" ref="errorContainer" id="errorContainer"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseCheckboxInput v-model="isCheck"
                                       :v="$v.isCheck"
                                       label="Check here if you intend to pay by check"
                                       slug="isCheck"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                     <b-table-simple hover small responsive>
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th>Fee Description</b-th>
                                <b-th>Fee Amount</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(tx, index) in renewalApplication.renewalFees" :key="index">
                                <b-td>{{tx.name}}</b-td>
                                <b-td>{{tx.amount | currency}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
               
                </b-col>
            </b-row>

        </div>

       
    </div>

</template>
<script>
import { required, requiredIf, email, minLength } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'

export default {
    data: () => {
        return {
            isCheck: false
        }
    },
    
    props: {
        renewalApplication: {
            type: Object,
            default () {
                return {
                    homeAddress: { 
                    }
                }
            }
        }
    },

    mixins: [
        commonOptions
    ],

    computed: {
        chargeLateFee() {
            return moment().isAfter(this.renewalApplication.lateFeeEffectiveDate)
        }
    },
    
    validations() {
        return {
            isCheck: { required: false }
        }            
    },

    methods: {
        validate() {
            var isValid = true            
            this.$emit('on-validate', this.$data, isValid)
            return isValid
        }
    }
}
</script>